import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-complete-letter-dialog',
    template: `
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h2 mat-dialog-title>{{ data.title }}</h2>
      </div>
      <div>
        <button mat-icon-button [mat-dialog-close]="true">
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div mat-dialog-content style="padding: 20px;word-break: break-word !important;">
      <div [innerHTML]="ownerNotes"></div>
    </div>
    <div mat-dialog-content style="padding: 20px;word-break: break-word !important;">
      <div [innerHTML]="safeContent"></div>
    </div>    
  `,
    styles: [`
    ::ng-deep mat-dialog-content {
      line-height: 1.6;
    }
    ::ng-deep mat-dialog-content p {
      margin-bottom: 1em;
    }
  `],
    standalone: false
})
export class CompleteLetterDialogComponent implements OnInit {
  safeContent: SafeHtml = '';
  ownerNotes: string = '';
  constructor(
    public dialogRef: MatDialogRef<CompleteLetterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; content: string; ownerNotes: string },
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    // Use bypassSecurityTrustHtml to display HTML content
    this.ownerNotes = this.data.ownerNotes || '';
    this.safeContent = this.sanitizer.bypassSecurityTrustHtml(this.data.content || '');
  }

  close(): void {
    this.dialogRef.close();
  }
}

